<div *ngIf="!hasFinishedLoading" class="comp-loader">
  <lib-loading></lib-loading>
</div>
<div class="dash-container" *ngIf="hasFinishedLoading">
  <div class="leads-container">
    <app-content-scrollable>
      <div #childComponent class='leads__container__menu'>
        <ul class="reports-menu">
          <li *ngFor="let menu of menus; let i = index" [ngClass]="{'reports__menu__link': isCurrentRoute(menu.path)}">
            <div *ngIf="isCurrentRoute(menu.path)" [ngClass]="{'reports__menu--selected': isCurrentRoute(menu.path)}">
              <a [ngClass]="{'reports__menu__link--selected': isCurrentRoute(menu.path), 'reports__menu__link': !isCurrentRoute(menu.path)}" [attr.id]="'selectedMenuItem' + i"
                [routerLink]="[menu.path]">{{menu.label}}</a>
            </div>
            <a *ngIf="!isCurrentRoute(menu.path)" [ngClass]="{'reports__menu__link--selected': isCurrentRoute(menu.path), 'reports__menu__link': !isCurrentRoute(menu.path)}" [attr.id]="'MenuItem' + i"
              [routerLink]="[menu.path]">{{menu.label}}</a>
          </li>
        </ul>
      </div>
    </app-content-scrollable>
    <div class="reports-content">
      <router-outlet class='flex-width'></router-outlet>
    </div>
  </div>
</div>